const faqItems = [
  {
    q: '色影视是否需要注册才能观看？',
    a: '完全不需要！色影视所有影视内容均可免费在线观看，无需注册、无需登录，打开网站就能直接播放，真正做到即点即看，方便快捷。',
  },
  {
    q: '春色影视最新网址入口在哪里？',
    a: '春色影视最新网址入口由本站持续维护更新。建议您收藏本站（色影视）作为永久入口，我们会及时同步春色影视官网新地址，确保您随时都能顺利访问。',
  },
  {
    q: '播放过程中会不会卡顿缓冲？',
    a: '色影视采用多线路智能切换技术，系统会自动选择最优播放线路。在网络正常的情况下，高清视频也能做到秒开不缓冲。如果遇到卡顿，可以手动切换备用线路。',
  },
  {
    q: '支持哪些设备观看？',
    a: '色影视全面支持电脑、平板和手机端观看，适配各种屏幕尺寸。我们还提供移动客户端 APP，在手机端获得更流畅、更省流量的观影体验。',
  },
  {
    q: '影视资源更新频率如何？',
    a: '我们的资源库每日更新，新上映的电影、热播电视剧都会在第一时间同步上线。国产剧、韩剧、美剧、日漫等热门内容基本能做到同步更新，让您不再错过任何精彩。',
  },
  {
    q: '观看影视是否完全免费？',
    a: '是的，色影视承诺所有影视内容永久免费。我们不收取任何费用，也不会在播放过程中插播强制广告。如果您喜欢我们的服务，欢迎推荐给身边的朋友。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center">
          常见问题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">关于色影视的常见疑问解答</p>

        <div className="mt-10 space-y-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-5 md:p-6">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 flex items-start gap-3 font-heading">
                <span className="text-primary-500 shrink-0 mt-0.5">Q</span>
                <span>{item.q}</span>
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}